import React, { FC } from 'react';
import { Field, Icon, TextInput } from '@kontentino/ui';
import { PostComposerFormState } from 'app/modules/posts/modules/post/components/composer/utils/postComposerFormState';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { UseSetStateAction } from 'utils/hooks/useSetState';
import { useTranslation } from 'react-i18next';

type Props = {
  value: PostComposerFormState;
  onChange: UseSetStateAction<PostComposerFormState>;
};

const PostComposerContentFacebookVideoTitle: FC<Props> = ({
  onChange,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <Field.Group>
      <Field.Label required>{t('videoTitle')}</Field.Label>
      <TextInput
        value={value?.attachments?.cards[0]?.title || ''}
        onChange={(e) => {
          onChange((prev) => ({
            attachments: {
              ...prev.attachments,
              cards: prev.attachments.cards.map((attachment) => ({
                ...attachment,
                title: e.target.value,
              })),
            },
          }));
        }}
      />
      <Field.Caption>
        <Icon icon={faCircleInfo} size="sm" />
        {t('shownInTheVideoLibraryOfYourPageOnFacebook')}
      </Field.Caption>
    </Field.Group>
  );
};

export default PostComposerContentFacebookVideoTitle;
